import React from 'react';
import { Route, Switch } from 'react-router-dom';

import GiftManagement from 'features/bonusProgram/view/desktop/GiftManagement';

const BonusProgramModule = (
  <Route key="/bonus-promo" path="/bonus-promo">
    <Switch>
      <Route key="/bonus-promo/management/:id" path="/bonus-promo/management/:id" component={GiftManagement} />
      <Route key="/bonus-promo/management" path="/bonus-promo/management" component={GiftManagement} />
    </Switch>
  </Route>
);

export default BonusProgramModule;
